import React, { useState, useEffect } from 'react';
import {
  HeroSection,
  HeroBackground,
  HeroOverlay,
  Container,
  HeroContent,
  HeroText,
  HeroTitle,
  Highlight,
  HeroSubtitle,
  HeroFeatures,
  Feature,
  FeatureIcon,
  HeroActions,
  PrimaryButton,
  SecondaryButton,
  HeroImage,
  HeroCard,
  RatingDisplay
} from './Hero.styles.jsx';

// Google Place ID for fetching rating (no fallback for security)
const GOOGLE_PLACE_ID = process.env.REACT_APP_GOOGLE_PLACE_ID || '';

// Render 5 stars with proper fill based on rating
const renderStars = (rating) => {
  return Array.from({ length: 5 }, (_, i) => (
    <span key={i} style={{ display: 'inline-flex', width: '20px', height: '20px' }}>
      <svg width="20" height="20" viewBox="0 0 24 24" fill={i < Math.round(rating) ? "#fbbc04" : "#e5e7eb"}>
        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
      </svg>
    </span>
  ));
};

const Hero = () => {
  const [rating, setRating] = useState(null);
  const [totalReviews, setTotalReviews] = useState(0);

  // Fetch rating for display
  useEffect(() => {
    if (GOOGLE_PLACE_ID) {
      const functionUrl = `/api/getGoogleReviews?place_id=${GOOGLE_PLACE_ID}`;
      
      fetch(functionUrl)
        .then(res => res.json())
        .then(data => {
          if (data.status === 'OK' && data.result) {
            setRating(data.result.rating || 0);
            setTotalReviews(data.result.user_ratings_total || 0);
          }
        })
        .catch(() => {
          // Silently fail - rating display is optional
        });
    }
  }, []);

  return (
    <HeroSection>
      <HeroBackground>
        <HeroOverlay></HeroOverlay>
      </HeroBackground>
      
      <Container>
        <HeroContent>
          <HeroText>
            {rating && rating > 0 && (
              <RatingDisplay>
                <span className="rating-number">{rating.toFixed(1)}</span>
                <span className="star-rating">
                  {renderStars(rating)}
                </span>
                {totalReviews > 0 && (
                  <span className="total-reviews">
                    ({totalReviews} {totalReviews === 1 ? 'recenzie' : 'recenzii'})
                  </span>
                )}
              </RatingDisplay>
            )}
            <HeroTitle>
              Instalații Sanitare <Highlight>Profesionale</Highlight>
            </HeroTitle>
            <HeroSubtitle>
              Servicii complete de instalații sanitare, încălzire în pardoseală, 
              curățare chimică centrale și montaj calorifere. Calitate garantată!
            </HeroSubtitle>
            
            <HeroFeatures>
              <Feature>
                <FeatureIcon>✅</FeatureIcon>
                <span>Reparații rapide</span>
              </Feature>
              <Feature>
                <FeatureIcon>✅</FeatureIcon>
                <span>Garanție servicii</span>
              </Feature>
              <Feature>
                <FeatureIcon>✅</FeatureIcon>
                <span>Prețuri competitive</span>
              </Feature>
            </HeroFeatures>

            <HeroActions>
              <PrimaryButton href="tel:+40721150463">
                Sună: +40721150463
              </PrimaryButton>
              <SecondaryButton href="#servicii">
                Vezi Servicii
              </SecondaryButton>
            </HeroActions>
          </HeroText>
          
          <HeroImage>
            <HeroCard>
              <h3>Serviciile Noastre</h3>
              <ul>
                <li>Instalații sanitare</li>
                <li>Încălzire pardoseală</li>
                <li>Curățare chimică centrale</li>
                <li>Montaj calorifere</li>
                <li>Montaj baterii & chiuvete</li>
              </ul>
            </HeroCard>
          </HeroImage>
        </HeroContent>
      </Container>
    </HeroSection>
  );
};

export default Hero;

